import useSWR from 'swr';

import { Viewer } from './ViewerContext';

// Timer values
const ONE_SECOND = 1000;
const ONE_MINUTE = 60 * ONE_SECOND;
const FOURTEEN_MINUTES = 14 * ONE_MINUTE;

export function useSetUpJwtPolling({
  viewer,
  onSuccess,
}: {
  viewer: Viewer | null;
  onSuccess: (jwt: string) => void;
}) {
  const { mutate } = useSWR(
    () => {
      if (!viewer) {
        return null;
      }
      return '/_next/jwt';
    },

    (key) =>
      fetch(key, { headers: { 'X-Requested-With': 'XMLHttpRequest ' } })
        .then((res) => res.json())
        .then((json) => json.token),
    {
      onSuccess,
      refreshInterval: FOURTEEN_MINUTES,
      refreshWhenHidden: true,
      revalidateOnReconnect: true,
      revalidateOnFocus: true,
      revalidateOnMount: false,
    },
  );

  return { refreshJwt: mutate };
}
